export default __webpack_public_path__ + "static/media/brandballoon-three.f63a61bc.png";